<template>
    <PortalMorphLoader overlay />
</template>

<script>
import PortalMorphLoader from './PortalMorphLoader.vue';

export default {
    components: {
        PortalMorphLoader,
    },
};
</script>
